//@flow
import * as React from 'react';
import * as Immutable from 'immutable';
import classnames from 'classnames';
import _ from 'lodash';

import GoogleMap from 'common/components/core/map/BaseGoogleMap';
import theme from './BaseGeocoderMap.scss';
import GeocoderMarker, {
    SpiderGeocoderMarker
} from 'common/components/core/markers/GeocoderMarker';
import { ZoomEnhancedAnimatedClusterMarker } from 'common/components/core/markers/ClusterMarker';
import { AnimatedSpiderMarker } from 'common/components/core/markers/SpiderMarker';
import NumberUtils from 'common/utils/NumberUtils';
import { MapWithClusteringfactory } from 'common/components/core/map/GoogleMapWithClustering';
import { AppBar } from 'react-toolbox/lib';
import LatLngUtils from 'common/utils/LatLngUtils';
import { Polyline } from 'common/components/core/map/Polyline';
import { animatedClusterMarkerFactory } from 'common/components/core/markers/AnimatedClusteredMarker';
import { getMarkerColorFromConfidence } from 'common/components/core/util/MarkerColorUtil';
import clusterMarkerTheme from 'common/components/core/markers/ClusterMarker.scss';
import geocoderMarkerTheme from 'common/components/core/markers/GeocoderMarker.scss';
import NonGeocodedMarker from 'common/components/core/markers/NonGeocodedMarker';
import { IconMenu, MenuItem } from 'common/components/core/menu';
import { Button, ButtonTypes } from 'common/components/core/button';
import Switch from 'common/components/core/switch';
import { MarkerType } from 'common/enums/MapEnum';
import TextColor from 'common/components/core/colors/text.scss';
import { translate } from 'react-i18next';
import { GeocodeEditLocation } from 'common/models/internal/GeocodeEditLocation';
import { AccuracyCategoryType } from 'common/models/internal/GeocodeVerifiedGeometry';
import GeocodeEditUtils from 'common/utils/GeocodeEditUtils';
import { Loader } from 'common/components/core/loader/Loader';
import { SizeEnum } from 'common/enums/UIEnums';
import popOverFactory, {
    PopoverTriggerEnum
} from 'common/components/core/popover/popOverFactory';
import { dashboardColors } from 'common/enums/ColorEnum';
import {
    PermissionMatch,
    RoleOperationEnum,
    AccessDeniedMessage
} from 'common/modules/rbac';
import { Heading } from '@locus-taxy/neo-ui';
import { HomebaseType } from 'common/models/internal/MasterHomebase';

const ClusteredMap = MapWithClusteringfactory(
    GoogleMap,
    ZoomEnhancedAnimatedClusterMarker,
    AnimatedSpiderMarker
);
const AnimatedGeocoderClusterMarker = animatedClusterMarkerFactory(
    GeocoderMarker
);
const AnimatedGeocoderClusterMarkerWithPopover = popOverFactory({
    Component: AnimatedGeocoderClusterMarker
});
type Props = {
    locations: Immutable.List<GeocodeEditLocation>
};

type State = {
    draggable: boolean,
    locations: Immutable.List<GeocodeEditLocation>,
    showOriginalColor: boolean
};

class BaseGeocoderMap extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            draggable: true,
            locations: props.locations,
            showOriginalColor: false
        };
        this.isFitToBoundEnabled = true;
        this.draggingMarkerLatLng = null;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { locations } = this.props;
        if (nextProps.locations !== locations) {
            this.setState({ locations: nextProps.locations });
        }

        if (this.state.map) {
            var nextSelectedLocation;
            var nextSelectedLatLng;
            var nextOriginalLatLng;
            var selectedLocation;
            var selectedLatLng;
            var originalLatLng;
            const { selectedLocationId } = this.props;
            const {
                selectedLocationId: nextSelectedLocationId,
                locations: nextLocations
            } = nextProps;
            if (!_.isUndefined(nextSelectedLocationId)) {
                nextSelectedLocation = this.getSelectedLocation(
                    nextLocations,
                    nextSelectedLocationId
                );
                nextSelectedLatLng =
                    nextSelectedLocation &&
                    nextSelectedLocation.getIn(['geometry', 'latLng']);
                nextOriginalLatLng =
                    nextSelectedLocation &&
                    this.getOriginalLatLng(nextSelectedLocation);
            }
            if (!_.isUndefined(selectedLocationId)) {
                selectedLocation = this.getSelectedLocation(
                    locations,
                    selectedLocationId
                );
                selectedLatLng =
                    selectedLocation &&
                    selectedLocation.getIn(['geometry', 'latLng']);
                originalLatLng =
                    selectedLocation &&
                    this.getOriginalLatLng(selectedLocation);
            }
            if (
                (!_.isUndefined(nextSelectedLocationId) &&
                    selectedLocationId !== nextSelectedLocationId) ||
                !_.isEqual(nextOriginalLatLng, originalLatLng) ||
                !_.isEqual(nextSelectedLatLng, selectedLatLng)
            ) {
                var latLngs = [];
                nextSelectedLatLng
                    ? latLngs.push(nextSelectedLatLng.toJS())
                    : null;
                nextOriginalLatLng
                    ? latLngs.push(nextOriginalLatLng.toJS())
                    : null;
                var bounds = LatLngUtils.getBoundsFromLatLngs(latLngs);
                var mapBounds = this.state.map.getBounds();
                for (var i = 0; i < latLngs.length; i++) {
                    var latLng = latLngs[i];
                    if (!mapBounds.contains(latLng)) {
                        this.isFitToBoundEnabled = true;
                        break;
                    }
                }

                if (!this.isFitToBoundEnabled) {
                    this.isFitToBoundEnabled = true;
                } else {
                    if (!bounds.isEmpty()) this.state.map.fitBounds(bounds);
                    if (latLngs.length === 1) this.state.map.setZoom(16);
                }
            } else if (this.props.searchText !== nextProps.searchText) {
                this.fitToBoundToAllLocations(nextProps);
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            (!prevState.map && this.state.map) ||
            (!prevProps.locations && this.props.locations && this.state.map)
        ) {
            this.fitToBoundToAllLocations(this.props);
        }
    }

    getSelectedLocation(locations, selectedLocationId) {
        return locations.find(
            locationEntity => locationEntity.id === selectedLocationId
        );
    }

    handleAddressChange = ({ locationEntity, latLng }) => {
        const { handleAddressChange } = this.props;
        if (!LatLngUtils.isValid(latLng)) {
            // If latlngs are invalid, dont send it to server
            // Happens if a marker was dragged out of map and dropped
            return;
        }
        handleAddressChange({ locationEntity, latLng });
    };

    handleLocationSelect = ({ locationEntity }) => {
        const { handleLocationSelect } = this.props;
        this.isFitToBoundEnabled = false;
        handleLocationSelect({ locationEntity });
    };

    fitToBoundToAllLocations = props => {
        if (!props.locations) return;
        const bounds = GeocodeEditUtils.getAllLocationsBounds(props.locations);
        if (!bounds.isEmpty() && this.state.map) {
            this.state.map.fitBounds(bounds);
        }
    };

    getOriginalLatLng(location) {
        if (!location.isOriginal) {
            return (
                location.originalGeometry && location.originalGeometry.latLng
            );
        }
        return undefined;
    }

    onChildMouseDown = () => {
        if (!this.props.isEditable) {
            return;
        }
        this.setState({ draggable: false });
    };

    onChildMouseMove = (hoverKey, childProps, latLng) => {
        if (!this.props.isEditable || !childProps.isEditable) {
            return;
        }
        if (childProps?.children?.props?.cluster) {
            // do nothing if it is a cluster
            return;
        }
        const { lat, lng } = latLng;
        if (!LatLngUtils.isValid(latLng)) {
            return;
        }

        if (!_.isNull(lat) && !_.isNull(lng)) {
            this.draggingMarkerLatLng = { lat, lng };

            const { draggingMarkerKey } = this.state;
            // TODO: Refactor use of ref to update position
            if (draggingMarkerKey) {
                this.draggingMarkerRef
                    ?.getWrappedInstance()
                    .updatePosition({ lat, lng });
            } else {
                this.setState({
                    draggingMarkerKey: hoverKey
                });
            }
        }
    };

    _onChildMouseUp = (hoverKey, childProps, currentlatLng, isDragging) => {
        this.setState({ draggable: true });
        if (childProps.cluster) {
            // Do nothing if it is cluster
            return;
        }
        var { locationEntity, isArchived } = childProps;
        if (isArchived) return;

        this.handleLocationSelect({ locationEntity });
        if (!this.props.isEditable) {
            return;
        }
        if (this.isDragging(hoverKey) || isDragging) {
            let latLngToSend;
            if (LatLngUtils.isValid(currentlatLng)) {
                latLngToSend = currentlatLng;
            } else {
                var locationId = this.state.locations.findIndex(
                    locationEntity => {
                        return this.isDragging(locationEntity.id);
                    }
                );
                if (locationId === -1) return;
                latLngToSend = this.draggingMarkerLatLng;
            }
            this.onChildMouseMove(hoverKey, childProps, latLngToSend);
            if (location) {
                this.handleAddressChange({
                    locationEntity,
                    latLng: latLngToSend
                });
            }
        }
        this.draggingMarkerLatLng = null;
        this.setState({
            draggingMarkerKey: undefined
        });
    };

    isDragging = key => {
        const { draggingMarkerKey } = this.state;
        // draggingMarkerKey is a string where as index is a number, hence double equals only.
        return !_.isUndefined(draggingMarkerKey) && draggingMarkerKey == key; //eslint-disable-line eqeqeq
    };

    onChildMouseUp = (hoverKey, childProps, latLng) => {
        let newChildProps = childProps;
        if (!childProps.shouldFilterFromCluster) {
            newChildProps = childProps.children.props;
        }
        this._onChildMouseUp(hoverKey, newChildProps, latLng);
    };

    getAddressMarkers = () => {
        const {
            selectedLocationId,
            shouldShowOriginalColor,
            isValidateGeocodesActive,
            t
        } = this.props;
        const { locations, map } = this.state;
        if (!locations) return [];
        var locationMarkers = [];
        locations.forEach(locationEntity => {
            var { index, id, geocodeVerifiedGeometry } = locationEntity;
            var isSelected = selectedLocationId == id; //eslint-disable-line eqeqeq

            if (locationEntity.type === HomebaseType.Crossdock) {
                const {
                    id,
                    geometry: { latLng }
                } = locationEntity;
                locationMarkers.push(
                    <AnimatedGeocoderClusterMarker
                        theme={geocoderMarkerTheme}
                        isEditable={false}
                        shouldFilterFromCluster
                        key={id}
                        lat={latLng?.lat}
                        lng={latLng?.lng}
                        color={dashboardColors.darkSkyBlue.name}
                        markerIcon="dispatcher_crossdock"
                        useNeoIcon
                        id={id}
                        locationEntity={locationEntity}
                        onChildMouseDown={this.onChildMouseDown}
                        map={map}
                    />
                );
                return;
            }

            var latLng = locationEntity.getIn(['geometry', 'latLng']);
            if (latLng) {
                var shouldFilterFromCluster = isSelected || this.isDragging(id);
                var originalConfidence;
                var { originalGeometry, isOriginal } = locationEntity;
                if (!isOriginal) {
                    originalConfidence = originalGeometry
                        ? originalGeometry.getIn(['confidence'], 'LOW')
                        : 'LOW';
                }
                const currentConfidence = locationEntity.getIn([
                    'geometry',
                    'confidence'
                ]);
                const currentConfidenceColor = getMarkerColorFromConfidence(
                    currentConfidence,
                    shouldShowOriginalColor
                );
                const originalConfidenceColor = originalConfidence
                    ? getMarkerColorFromConfidence(
                          originalConfidence,
                          shouldShowOriginalColor
                      )
                    : null;
                let markerColor = currentConfidenceColor;
                let geocodedLatLng;
                let isGeocodedLatLngDifferent = true;
                if (geocodeVerifiedGeometry && isValidateGeocodesActive) {
                    markerColor = geocodeVerifiedGeometry.getAccuracyConfidenceColor();
                    ({ geocodedLatLng } = geocodeVerifiedGeometry);
                    isGeocodedLatLngDifferent = geocodeVerifiedGeometry.isDifferentLatLng(
                        locationEntity.geometry
                    );
                }
                locationMarkers.push(
                    <AnimatedGeocoderClusterMarker
                        theme={geocoderMarkerTheme}
                        isEditable={this.props.isEditable}
                        isSelected={isSelected}
                        shouldFilterFromCluster={shouldFilterFromCluster}
                        key={id}
                        lat={latLng.get('lat')}
                        lng={latLng.get('lng')}
                        color={markerColor}
                        originalConfidenceColor={originalConfidenceColor}
                        confidence={currentConfidence}
                        className={classnames({
                            [geocoderMarkerTheme.originalConfidenceHighlight]:
                                currentConfidenceColor ===
                                originalConfidenceColor,
                            [geocoderMarkerTheme.hideMarker]: !!this.isDragging(
                                id
                            )
                        })}
                        markerLabel={NumberUtils.padLeft(index)}
                        id={id}
                        locationEntity={locationEntity}
                        onChildMouseMove={this.onChildMouseMove}
                        onChildMouseDown={this.onChildMouseDown}
                        onChildMouseUp={this._onChildMouseUp}
                        map={map}
                    />
                );

                if (isSelected) {
                    var originalLatLng = this.getOriginalLatLng(locationEntity);
                    if (originalLatLng) {
                        locationMarkers.push(
                            <AnimatedGeocoderClusterMarker
                                isEditable={false}
                                shouldFilterFromCluster
                                key={`LocationMarkerAudit${id}`}
                                lat={originalLatLng.get('lat')}
                                lng={originalLatLng.get('lng')}
                                isArchived
                                markerType={MarkerType.NON_HOVERABLE}
                                confidence={originalConfidence}
                                color={getMarkerColorFromConfidence(
                                    originalConfidence,
                                    this.props.shouldShowOriginalColor
                                )}
                                id={id}
                                markerLabel={NumberUtils.padLeft(index)}
                                map={this.state.map}
                                locationEntity={locationEntity}
                            />
                        );
                    }

                    if (
                        geocodedLatLng &&
                        isGeocodedLatLngDifferent &&
                        isValidateGeocodesActive
                    ) {
                        locationMarkers.push(
                            <AnimatedGeocoderClusterMarkerWithPopover
                                shouldFilterFromCluster
                                isSelected
                                isGeocodeVerifiedMarker
                                key={`LocationMarkerVerified${id}`}
                                lat={geocodedLatLng.lat}
                                lng={geocodedLatLng.lng}
                                markerType={MarkerType.NON_HOVERABLE}
                                confidence={'HIGH'}
                                color={getMarkerColorFromConfidence('HIGH')}
                                id={id}
                                markerLabel={NumberUtils.padLeft(index)}
                                map={this.state.map}
                                locationEntity={locationEntity}
                                popOverContent={t('geocodeMap.systemSuggested')}
                                triggerPopoverOn={PopoverTriggerEnum.Hover}
                            />
                        );
                    }
                }
            } else {
                if (this.state.map && isSelected) {
                    const originalConfidenceColor = getMarkerColorFromConfidence(
                        locationEntity.getIn(
                            ['originalGeometry', 'confidence'],
                            'LOW'
                        ),
                        this.props.shouldShowOriginalColor
                    );
                    const currentConfidenceColor = getMarkerColorFromConfidence(
                        locationEntity.getIn(['geometry', 'confidence']),
                        this.props.shouldShowOriginalColor
                    );
                    locationMarkers.push(
                        <NonGeocodedMarker
                            shouldFilterFromCluster
                            theme={clusterMarkerTheme}
                            key={'nonGeocodedMarker'}
                            markerLabel={NumberUtils.padLeft(index)}
                            color={currentConfidenceColor}
                            originalConfidenceColor={originalConfidenceColor}
                            confidence={locationEntity.getIn([
                                'geometry',
                                'confidence'
                            ])}
                            className={classnames({
                                [geocoderMarkerTheme.originalConfidenceHighlight]:
                                    currentConfidenceColor ===
                                    originalConfidenceColor
                            })}
                            bboxMap={this.clusterMap.getBBoxforMap()}
                            map={this.state.map}
                            id={locationEntity.id}
                            locationEntity={locationEntity}
                            handleLocationSelect={this.handleLocationSelect}
                            handleDragDone={
                                this.handleDragDoneForNonGeocodedMarker
                            }
                            isEditable={this.props.isEditable}
                            isVisible={isSelected}
                        />
                    );
                }
            }
        });
        return locationMarkers;
    };

    handleDragDoneForNonGeocodedMarker = (markerProps, screenPixel) => {
        var latLng = LatLngUtils.getPixelToLatLng(
            markerProps.bboxMap,
            markerProps.map,
            screenPixel
        );
        var { locationEntity } = markerProps;
        this.handleAddressChange({
            locationEntity,
            latLng
        });
    };

    getVerifiedAuditPolyline = () => {
        const {
            locations,
            selectedLocationId,
            isValidateGeocodesActive
        } = this.props;
        const { map } = this.state;
        if (
            !isValidateGeocodesActive ||
            _.isUndefined(selectedLocationId) ||
            !map ||
            !locations
        ) {
            return [];
        }
        const selectedLocation = locations.find(
            locationEntity => locationEntity.id === selectedLocationId
        );
        if (!selectedLocation) {
            return [];
        }
        const selectedLatLng = selectedLocation.getIn(['geometry', 'latLng']);
        const { geocodedLatLng } =
            selectedLocation.geocodeVerifiedGeometry || {};
        if (!geocodedLatLng || !selectedLatLng) {
            return [];
        }
        var path = [selectedLatLng.toJS(), geocodedLatLng.toJS()];
        return this.getPolyline({
            path,
            strokeOpacity: 1,
            strokeColor: dashboardColors.darkSkyBlue.code,
            key: 'verified-polyline'
        });
    };

    getDraggingMarker = () => {
        const { draggingMarkerKey, locations, map } = this.state;
        if (draggingMarkerKey) {
            const {
                selectedLocationId,
                shouldShowOriginalColor,
                isEditable,
                isValidateGeocodesActive
            } = this.props;

            var locationId = locations.findIndex(locationEntity => {
                // draggingMarkerKey is a string where as index is a number, hence double equals only.
                return locationEntity.id == draggingMarkerKey; // eslint-disable-line eqeqeq
            });
            if (locationId === -1) return;

            const draggingMarkerLocation = locations.get(locationId);
            var { index, id } = draggingMarkerLocation;
            var isSelected = selectedLocationId == id; //eslint-disable-line eqeqeq

            if (this.draggingMarkerLatLng) {
                var shouldFilterFromCluster = isSelected || this.isDragging(id);
                var originalConfidence;
                var {
                    originalGeometry,
                    isOriginal,
                    geocodeVerifiedGeometry
                } = draggingMarkerLocation;
                if (!isOriginal) {
                    originalConfidence = originalGeometry
                        ? originalGeometry.getIn(['confidence'], 'LOW')
                        : 'LOW';
                }
                const currentConfidence = draggingMarkerLocation.getIn([
                    'geometry',
                    'confidence'
                ]);
                const currentConfidenceColor = getMarkerColorFromConfidence(
                    currentConfidence,
                    shouldShowOriginalColor
                );
                let markerColor = currentConfidenceColor;
                if (geocodeVerifiedGeometry && isValidateGeocodesActive) {
                    markerColor = geocodeVerifiedGeometry.getAccuracyConfidenceColor();
                }
                const originalConfidenceColor = originalConfidence
                    ? getMarkerColorFromConfidence(
                          originalConfidence,
                          shouldShowOriginalColor
                      )
                    : null;

                return (
                    <SpiderGeocoderMarker
                        usePortal
                        locationEntity={draggingMarkerLocation}
                        ref={this.getDraggingMarkerRef}
                        theme={geocoderMarkerTheme}
                        key={'draggingMarker'}
                        shouldFilterFromCluster={shouldFilterFromCluster}
                        markerLabel={NumberUtils.padLeft(index)}
                        color={markerColor}
                        originalConfidenceColor={originalConfidenceColor}
                        confidence={draggingMarkerLocation.getIn([
                            'geometry',
                            'confidence'
                        ])}
                        className={classnames({
                            [geocoderMarkerTheme.originalConfidenceHighlight]:
                                currentConfidenceColor ===
                                originalConfidenceColor
                        })}
                        bboxMap={this.clusterMap.getBBoxforMap()}
                        map={map}
                        id={'draggingMarker'}
                        lat={this.draggingMarkerLatLng.lat}
                        lng={this.draggingMarkerLatLng.lng}
                        isEditable={isEditable}
                        isSelected={isSelected}
                        isVisible
                        handleDragDone={_.noop}
                        handleLocationSelect={_.noop}
                        onMouseLeave={_.noop}
                        onMouseEnter={_.noop}
                    />
                );
            }
        }
        return [];
    };

    getAuditPolyline = () => {
        const { locations, selectedLocationId } = this.props;
        const { map } = this.state;
        if (_.isUndefined(selectedLocationId) || !map || !locations) return [];
        const selectedLocation = locations.find(
            locationEntity => locationEntity.id === selectedLocationId
        );
        if (!selectedLocation) {
            return [];
        }
        const selectedLatLng = selectedLocation.getIn(['geometry', 'latLng']);
        const originalLatLng = this.getOriginalLatLng(selectedLocation);
        if (!originalLatLng || !selectedLatLng) return [];
        const path = [selectedLatLng.toJS(), originalLatLng.toJS()];
        return this.getPolyline({
            path,
            key: 'next-polyline'
        });
    };

    getPolyline = ({
        path,
        key,
        strokeColor = dashboardColors.slateGrey.code,
        strokeOpacity = 0.5
    }) => {
        const lineSymbol = {
            path: 'M 0,-1 0,1',
            scale: 4,
            strokeColor,
            strokeWeight: 4
        };
        const mapHelper = {
            map: this.state.map
        };
        const icons = [
            {
                icon: lineSymbol,
                offset: '0px',
                repeat: '20px'
            }
        ];
        return (
            <Polyline
                key={key}
                geodesic={false}
                icons={icons}
                mapHelper={mapHelper}
                path={path}
                shouldFilterFromCluster
                color={'transparent'}
                strokeOpacity={strokeOpacity}
            />
        );
    };

    onMapLoad = ({ map }) => {
        const { onMapLoad } = this.props;
        this.setState({ map });
        onMapLoad && onMapLoad();
    };

    _forceUpdate = () => {
        this.forceUpdate();
    };

    getClusterMapRef = ref => {
        this.clusterMap = ref;
    };

    overrideClusterConfidenceColor = points => {
        const { isValidateGeocodesActive } = this.props;
        const firstPoint = points[0].child;
        const areAllMarkersInSpiderOfSamePool = points.every(point => {
            return point.child.props.color === firstPoint.props.color;
        });
        if (areAllMarkersInSpiderOfSamePool) {
            return firstPoint.props.color;
        }

        if (isValidateGeocodesActive) {
            return this.getAccuracyConfidenceColorFromList(points);
        }
    };

    getAccuracyConfidenceColorFromList(points) {
        const sortedAccuracyList = [
            AccuracyCategoryType.CANT_VERIFY,
            AccuracyCategoryType.POSSIBLY_ACCURATE,
            AccuracyCategoryType.POSSIBLY_INACCURATE,
            AccuracyCategoryType.HIGHLY_INACCURATE,
            AccuracyCategoryType.HIGHLY_ACCURATE
        ];
        const sortedPoints = _.sortBy(points, point => {
            const location = point.child.props.locationEntity;
            return sortedAccuracyList.findIndex(
                accuracyCategory =>
                    accuracyCategory ===
                    location?.geocodeVerifiedGeometry?.accuracyCategory
            );
        });
        // points are culsters,
        // so we are trying to figure out the cluster color
        // by sorting clusters & iterating through children
        const point = sortedPoints
            .filter(point => !point.child.props.isGeocodeVerifiedMarker)
            .find(
                point =>
                    point.child.props.locationEntity.geocodeVerifiedGeometry
                        ?.accuracyCategory
            );
        return point?.child.props.color;
    }
    renderCheckGeocode() {
        const {
            t,
            isValidateGeocodesActive,
            isValidatingGeocodes,
            onToggleValidateGeocodes
        } = this.props;
        if (!onToggleValidateGeocodes) {
            return null;
        }
        return (
            <div className={theme.checkGeocodeWrap}>
                <Switch
                    disabled={isValidatingGeocodes}
                    theme={theme}
                    className={theme.checkGeocodeToggle}
                    checked={isValidateGeocodesActive}
                    label={t('geocodeMap.checkGeocodes')}
                    onChange={onToggleValidateGeocodes}
                />
                {isValidatingGeocodes ? (
                    <Loader
                        relative
                        active
                        theme={theme}
                        size={SizeEnum.Small}
                    />
                ) : null}
            </div>
        );
    }
    getDraggingMarkerRef = ref => {
        this.draggingMarkerRef = ref;
    };

    render() {
        const {
            isEditable,
            isLoading,
            shouldShowOriginalColor,
            noOfLocationsThatNeedAttention,
            precision,
            onTogglePrecision,
            onClose,
            handleHideSpider,
            t,
            onMapCenterAndRadiusUpdate
        } = this.props;
        const { map, draggable } = this.state;
        const rightText = isLoading ? (
            '-'
        ) : isEditable ? (
            noOfLocationsThatNeedAttention > 0 ? (
                <span className={TextColor['salmon-two']}>
                    {t('addressAttention', {
                        count: noOfLocationsThatNeedAttention
                    })}
                </span>
            ) : null
        ) : (
            <span className={TextColor['dark-sky-blue']}>
                {t('noNewEdits').toUpperCase()}
            </span>
        );
        return (
            <div className={theme.geocoderMap}>
                <AppBar
                    flat
                    theme={theme}
                    title={isLoading || isEditable ? t('checkAddress') : null}
                >
                    <div className={theme.right}>
                        <PermissionMatch
                            operations={RoleOperationEnum.UPDATE_BATCH_GEOCODE}
                            // eslint-disable-next-line react/jsx-no-bind
                            render={hasPermission => {
                                if (!hasPermission) {
                                    return (
                                        <Heading level="4">
                                            <AccessDeniedMessage
                                                action={t('edit_plural')}
                                            />
                                        </Heading>
                                    );
                                }
                                return rightText ? (
                                    <span className={theme.text}>
                                        {rightText}
                                    </span>
                                ) : null;
                            }}
                        />
                        {onTogglePrecision ? (
                            <IconMenu
                                icon={'ellipsis_v'}
                                theme={theme}
                                position="topRight"
                                menuRipple={false}
                            >
                                <MenuItem
                                    value=""
                                    caption={precision}
                                    theme={theme}
                                    onClick={onTogglePrecision}
                                />
                            </IconMenu>
                        ) : null}
                        {this.renderCheckGeocode()}
                        {onClose ? (
                            <Button
                                buttonType={ButtonTypes.Icon}
                                circle
                                icon="cancel"
                                className={theme.closeBtn}
                                theme={theme}
                                onClick={onClose}
                            />
                        ) : null}
                    </div>
                </AppBar>
                <div className={theme.mapWrap}>
                    <ClusteredMap
                        showPopupOnClick
                        ref={this.getClusterMapRef}
                        enableClustering
                        doNotApplyBlackTheme
                        enableFitToBounds={false}
                        onGoogleApiLoaded={this.onMapLoad}
                        map={map}
                        onChange={this._forceUpdate}
                        onChildMouseDown={this.onChildMouseDown}
                        onChildMouseUp={this.onChildMouseUp}
                        onChildMouseMove={this.onChildMouseMove}
                        disableDrag={!draggable}
                        shouldShowOriginalColor={shouldShowOriginalColor}
                        handleHideSpider={handleHideSpider}
                        handleLocationSelect={this.handleLocationSelect}
                        onMapCenterAndRadiusUpdate={onMapCenterAndRadiusUpdate}
                        theme={theme}
                        overrideClusterConfidenceColor={
                            this.overrideClusterConfidenceColor
                        }
                    >
                        {this.getAddressMarkers()}
                        {this.getDraggingMarker()}
                        {this.getAuditPolyline()}
                        {this.getVerifiedAuditPolyline()}
                    </ClusteredMap>
                </div>
            </div>
        );
    }
}

export default translate()(BaseGeocoderMap);
